import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV1 } from '../baseQueryV1';

export const firebaseApi = createApi({
  reducerPath: 'firebaseApi',
  baseQuery: baseQueryV1,
  endpoints: (builder) => ({
    saveToken: builder.mutation({
      query: (payload) => ({
        url: 'notifications/save-token',
        method: 'POST',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
    }),
  }),
});

export const { useSaveTokenMutation } = firebaseApi;
